import { AssistantConversationCreatePayloadDto } from "@core/data/dto/assistant.dto";
import { AssistantRepository } from "@core/data/repositories/assistant.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { AssistantConversation } from "@core/domain/models/assistant-conversation.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class StartAssistantConversationUseCase {
    constructor(
        @inject(AssistantRepository)
        private readonly repository: AssistantRepository,
    ) {}

    async execute(
        payload?: AssistantConversationCreatePayloadDto,
    ): Promise<Either<FallbackError, AssistantConversation>> {
        return this.repository.createConversation(payload);
    }
}
